import Vue from 'vue'
import XRtoast  from './toast.vue'

export default XRtoast




// WEBPACK FOOTER //
// ./src/components/tools/index.js